import hotair from '../images/hotair.jpg';
import lions from '../images/lions.jpg';
import elephant from '../images/elephant.jpg';
import girrafes from '../images/girrafes.jpg';
import flamingo from '../images/flamingo.jpg';

const urls = [
  { url: girrafes, name: 'Girrafe Center' },
  { url: flamingo, name: 'Lake Nakuru' },
  { url: hotair, name: 'Hot Air Baloons' },
  { url: lions, name: 'National Park' },
  { url: elephant, name: 'Serengeti' },
];

export { urls };
